import React, { useEffect } from 'react';
import { useCustomMutation } from '../../utils/useCustomMutation';
import { postMethod } from '../../api/common';
import { ConfirmModal } from '../../components/modal/confirm-modal/ConfirmModal.component';
import { useReducerSpread } from '../../utils/common.util';
import {
  Checkbox,
  TextInput,
  Select,
  SelectItem,
} from 'carbon-components-react';

const initialData = {
  id: null,
  description: '',
  semester: false,
  isPreSchool: false,
  educationLevel: 'UnAssigned',
};
export default function EditClass({
  isOpen,
  closeModal,
  classItem,
  refetchClasses,
}) {
  const [formData, setFormData] = useReducerSpread(initialData);

  useEffect(() => {
    setFormData({
      id: classItem?.id || null,
      description: classItem?.description || '',
      semester: classItem?.semester || false,
      isPreSchool: classItem?.isPreSchool || false,
      educationLevel: classItem?.educationLevel || 'UnAssigned',
    });
  }, [classItem, setFormData]);

  const { trigger, error, isMutating, reset } = useCustomMutation(
    'class/create-new',
    (url, { arg }) => postMethod(url, arg),
  );

  function handleClose() {
    closeModal();
    reset();
  }

  return (
    <ConfirmModal
      title="Edit Class"
      isOpen={isOpen}
      description={
        <>
          <div className="mt-20">
            <TextInput
              id="edit-description"
              name="edit-description"
              labelText="Description"
              value={formData.description}
              onChange={(e) => setFormData({ description: e.target.value })}
              placeholder="E.g. Grade 1 or Class 1"
            />
            <Checkbox
              id="edit-semester"
              name="edit-semester"
              labelText="Semester"
              checked={formData.semester}
              onChange={(value) => setFormData({ semester: value })}
              placeholder="E.g. Grade 1 or Class 1"
              className="mt-20"
            />
            <Checkbox
              id="edit-isPreSchool"
              name="edit-isPreSchool"
              labelText="PreSchool"
              checked={formData.isPreSchool}
              onChange={(value) =>
                setFormData({
                  isPreSchool: value,
                  educationLevel: value ? 'UnAssigned' : formData.educationLevel,
                })
              }
              placeholder=""
              className="mt-20"
            />
            <Select
              id="edit-education-level"
              name="edit-educationLevel"
              labelText="Education Level"
              value={formData.educationLevel}
              disabled={formData.isPreSchool}
              onChange={(e) => setFormData({ educationLevel: e.target.value })}
              className="mt-20"
            >
              <SelectItem
                selected={formData.educationLevel === 'UnAssigned'}
                text="UnAssigned"
                value="UnAssigned"
              />
              <SelectItem
                selected={formData.educationLevel === 'PrimarySchool'}
                text="Primary School"
                value="PrimarySchool"
              />
              <SelectItem
                selected={formData.educationLevel === 'HighSchool'}
                text="High School"
                value="HighSchool"
              />
            </Select>
          </div>
        </>
      }
      actionText="UPATE"
      onClick={() => {
        trigger(formData, {
          onSuccess: () => {
            refetchClasses();
            handleClose();
          },
        });
      }}
      disabled={!formData.description}
      isLoading={isMutating}
      errorMessage={error?.message ?? null}
      closeModal={handleClose}
      actionBtnClasses="primary"
    />
  );
}
